import * as React from 'react';
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  makeStyles,
  TextField,
  Typography,
} from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { updateOneCourseAsync } from './CourseStore/courseStoreSlice';
import useToast from '../../../hooks/useToast';
import useLoader from '../../../hooks/useLoader';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
};

const useStyles = makeStyles({
  input: {
    '& input[type=number]': {
      '-moz-appearance': 'textfield',
    },
    '& input[type=number]::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '& input[type=number]::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
  },
});

const UpdateCourseForm = ({ fetchDefaultData, defaultData, handleClose }) => {
  const [title, setTitle] = React.useState(defaultData.title);
  const [description, setDescription] = React.useState(defaultData.description);
  const [coursePrice, setCoursePrice] = React.useState(defaultData.price);
  const [priceInDollar, setPriceInDollar] = React.useState(
    defaultData.metaData.priceInDollar
  );
  const [isPopular, setIsPopular] = React.useState(
    defaultData.metaData.popular
  );
  const [isFeatured, setIsFeatured] = React.useState(
    defaultData.metaData.featured
  );
  const [slug, setSlug] = React.useState('');

  const classes = useStyles();

  // console.log('important data',{ defaultData });

  React.useEffect(() => {
    if (
      defaultData &&
      defaultData._id &&
      defaultData.title &&
      defaultData.description &&
      defaultData.price &&
      defaultData.metaData.priceInDollar
    ) {
      setTitle(defaultData.title);
      setDescription(defaultData.description);
      setCoursePrice(defaultData.price);
      setPriceInDollar(defaultData.metaData.priceInDollar);
    }
    if (defaultData && defaultData.slug && defaultData.slug !== '') {
      setSlug(defaultData.slug.split(' ').join('-').toLowerCase());
    }
  }, [defaultData]);

  const dispatch = useDispatch();
  const { ErrorToast, SuccessToast } = useToast();
  const { handleLoader } = useLoader();

  const updateCourse = async () => {
    try {
      handleLoader(true);
      dispatch(
        updateOneCourseAsync({
          _id: defaultData._id,
          bodyData: {
            price: coursePrice,
            title: title.trim(),
            description: description.trim(),
            slug: slug.trim(),
            metaData: {
              // keywords: ['carrer studies', 'online'],
              // duration: '6 Months',
              // certificate: true,
              priceInDollar: priceInDollar,
              popular: isPopular,
              featured: isFeatured,
            },
          },
        })
      )
        .unwrap()
        .then((res) => {
          if (res) {
            SuccessToast(`Course updated successfully.`);
            fetchDefaultData();
            handleLoader(false);

            handleClose();
          } else {
            handleLoader(false);
          }
        });
    } catch (error) {
      console.log(error);
      handleLoader(false);
      ErrorToast('Course could not be added. Please try again!');
    }
  };

  return (
    <Box sx={style}>
      <Box>
        <Typography>Update a Course</Typography>
        <Box alignItems="center">
          <Box my={2}>
            <TextField
              required
              label="Course title"
              variant="outlined"
              value={title}
              onChange={(e) => {
                e.preventDefault();
                setTitle(e.target.value);
              }}
              size="small"
              fullWidth
              defaultValue=""
            />
          </Box>
        </Box>
        <Box my={2} display="flex" alignItems="center">
          <TextField
            required
            label="Course description"
            variant="outlined"
            size="small"
            fullWidth
            value={description}
            onChange={(e) => {
              e.preventDefault();
              setDescription(e.target.value);
            }}
            defaultValue=""
          />
        </Box>
        <Box my={2} display="flex" alignItems="center">
          <TextField
            type={'number'}
            required
            label="Course Price"
            variant="outlined"
            size="small"
            fullWidth
            value={coursePrice}
            onChange={(e) => {
              e.preventDefault();
              setCoursePrice(e.target.value);
            }}
            className={classes.input}
          />
        </Box>
        <Box my={2} display="flex" alignItems="center">
          <TextField
            type={'number'}
            required
            label="Course Price in Dollar.."
            variant="outlined"
            size="small"
            fullWidth
            value={priceInDollar}
            onChange={(e) => {
              e.preventDefault();
              setPriceInDollar(e.target.value);
            }}
            className={classes.input}
          />
        </Box>
        <Box my={2} display="flex" alignItems="center">
          <TextField
            required
            label="Course Slug"
            variant="outlined"
            size="small"
            fullWidth
            value={slug}
            onChange={(e) => {
              e.preventDefault();
              setSlug(e.target.value.split(' ').join('-').toLowerCase());
            }}
            defaultValue=""
          />
        </Box>
        <Box my={2}>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  checked={isPopular}
                  onChange={(e) => {
                    setIsPopular(e.target.checked);
                  }}
                />
              }
              label="Is Popular Course ?"
            />
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  checked={isFeatured}
                  onChange={(e) => {
                    setIsFeatured(e.target.checked);
                  }}
                />
              }
              label="Is Featured Course ?"
            />
          </FormGroup>
        </Box>

        <Box my={2}>
          <Button variant="contained" color="primary" onClick={updateCourse}>
            Update Course
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default UpdateCourseForm;
